import { createAction, createNetworkActions } from "~/utils/actions";

export default {
	...createNetworkActions("NORSK_PENSJON"),
	...createNetworkActions("NORSK_PENSJON_PKBS"),
	...createAction("RESET_NORSK_PENSJON"),
	...createAction("SET_EXTRA_SAVINGS"),
};
